export const ROLES = [
  "Songwriter/Topline",
  "Recording Artist",
  "Producer",
  "Beatmaker",
  "Mixing/Mastering Engineer",
  "Vocalist",
  "Instrumentalist",
];

export const GENRES = [
  "Pop",
  "Hip-Hop/Rap",
  "R&B/Soul",
  "Country",
  "Folk/Americana",
  "Rock",
  "Indie/Alternative",
  "Electronic/EDM",
  "Latin",
  "Christian/Worship",
  "Afrobeats",
  "Jazz",
];
